import {
  Component, Injector,
  NgModule,
  ElementRef,
  ViewEncapsulation
} from '@angular/core';

import { AuthGuardService } from '../../services';
import { OTranslateService } from '../../services';
import { OSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';

export const DEFAULT_INPUTS_O_BAR_MENU = [
  // title [string]: menu title. Default: no value.
  'menuTitle: title',

  // tooltip [string]: menu tooltip. Default: 'title' value.
  'tooltip'
];


export class OBarMenuComponent {

  public static DEFAULT_INPUTS_O_BAR_MENU = DEFAULT_INPUTS_O_BAR_MENU;

  protected authGuardService: AuthGuardService;
  protected translateService: OTranslateService;

  protected _menuTitle: string;
  protected _tooltip: string;
  protected _id: string;

  constructor(
    protected elRef: ElementRef,
    protected injector: Injector) {
    this.id = 'm_' + String((new Date()).getTime() + Math.random());
    this.authGuardService = this.injector.get(AuthGuardService);
    this.translateService = this.injector.get(OTranslateService);
  }

  public ngOnInit() {

    if (!this.tooltip) {
      this.tooltip = this.menuTitle;
    }
    if (this.translateService) {
      this.translateService.onLanguageChanged.subscribe(() => {
        this.setDOMTitle();
      });
      this.setDOMTitle();
    }
  }

  setDOMTitle() {
    let tooltip = this.translateService.get(this.tooltip);
    this.elRef.nativeElement.setAttribute('title', tooltip);
  }

  collapseAll() {
    let inputs = this.elRef.nativeElement.querySelectorAll('input');
    if (inputs) {
      inputs.forEach(element => {
        element.checked = false;
      });
    }

    let fakeLis = this.elRef.nativeElement.querySelectorAll('.fake-li-hover');
    if (fakeLis) {
      fakeLis.forEach(element => {
        element.classList.remove('fake-li-hover');
      });
    }
  }

  getAuthGuardService() : AuthGuardService {
    return this.authGuardService;
  }

  get menuTitle(): string {
    return this._menuTitle;
  }

  set menuTitle(val : string) {
    this._menuTitle = val;
  }

  get tooltip(): string {
    return this._tooltip;
  }

  set tooltip(val : string) {
    this._tooltip = val;
  }

  get id(): string {
    return this._id;
  }

  set id(val : string) {
    this._id = val;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-bar-menu',
  template: `
    <md-toolbar color="primary">
      <nav>
        <md-icon class="mat-24 menu-icon toggle" (click)="input.checked = !input.checked">menu</md-icon>
        <label [attr.for]="id" class="toggle title-label">{{ menuTitle | oTranslate }}</label>
        <input #input [attr.id]="id" type="checkbox" />
        <div class="fake-ul mat-primary menu">
          <ng-content></ng-content>
        </div>
      </nav>
    </md-toolbar>
  `,
  styles: [`
    o-bar-menu{box-shadow:0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)}o-bar-menu .toggle,o-bar-menu input{display:none}o-bar-menu nav{margin:0;padding:0}o-bar-menu nav:after{content:"";display:table;clear:both}o-bar-menu nav .fake-ul{float:right;padding:0;margin:0;list-style:none;position:relative}o-bar-menu nav .fake-ul.menu>o-bar-menu-item .o-bar-menu-item-title{top:0px;padding-left:0px}o-bar-menu nav .fake-ul .fake-li{margin:0px;display:inline-block;cursor:pointer}o-bar-menu nav .fake-ul .fake-ul{display:none;position:absolute;top:60px;background-color:#FFF}o-bar-menu nav .fake-ul .fake-ul a{color:rgba(0,0,0,0.7)}o-bar-menu nav .fake-ul .fake-ul .fake-li{min-width:250px;width:250px;float:none;display:list-item;position:relative;white-space:nowrap;background-color:#FFF}o-bar-menu nav .fake-ul .fake-ul .fake-ul{top:0px}o-bar-menu nav .fake-ul .fake-ul .fake-ul .fake-li{position:relative;top:0px;left:0px}o-bar-menu nav a{display:block;padding:0 20px;color:#FFF;font-size:20px;line-height:60px;text-decoration:none}o-bar-menu .fake-li>a:after{content:' +'}o-bar-menu .fake-li>a:only-child:after{content:''}@media all and (min-width: 768px){o-bar-menu nav .fake-ul .fake-li .fake-ul .fake-li-hover{background:rgba(0,0,0,0.16)}o-bar-menu nav .fake-ul .fake-li-hover{background-color:rgba(255,255,255,0.16)}o-bar-menu nav .fake-ul .fake-li-hover>.fake-ul{display:inline-block;z-index:1000}o-bar-menu nav .fake-ul .fake-ul .fake-li-hover>.fake-ul{display:inline-block;z-index:1000;left:250px}}@media all and (max-width: 767px){o-bar-menu mat-toolbar-row{height:auto !important}o-bar-menu nav{margin:0;width:100%}o-bar-menu nav a:hover{background-color:rgba(255,255,255,0.15)}o-bar-menu nav .fake-ul{width:100%;border-top:1px solid rgba(255,255,255,0.5)}o-bar-menu nav .fake-ul .fake-li{width:100%}o-bar-menu nav .fake-ul .fake-li .fake-ul .fake-li .toggle{background-color:rgba(255,255,255,0.15)}o-bar-menu nav .fake-ul .fake-ul{float:none;position:static;width:100%}o-bar-menu nav .fake-ul .fake-ul .fake-li{width:100%}o-bar-menu nav .fake-ul .fake-ul a{background-color:rgba(255,255,255,0.15)}o-bar-menu nav .fake-ul .fake-ul .toggle,o-bar-menu nav .fake-ul .fake-ul a{padding:0 40px}o-bar-menu nav .fake-ul .fake-ul .fake-ul .fake-li{position:static}o-bar-menu nav .fake-ul .fake-ul .fake-ul a{padding:0 80px;background-color:rgba(255,255,255,0.15)}o-bar-menu .toggle{display:block;padding:0 20px;font-size:20px;line-height:60px;text-decoration:none;border:none;cursor:pointer}o-bar-menu .toggle:hover{background-color:rgba(255,255,255,0.15)}o-bar-menu .toggle+a{display:none !important}o-bar-menu .menu{display:none;float:left !important}o-bar-menu label.title-label{display:inline-block}o-bar-menu md-icon.menu-icon{vertical-align:middle;display:inline-block;line-height:1;padding:0 4px}o-bar-menu input:checked+.fake-ul{display:block}}@media all and (max-width: 330px){o-bar-menu nav .fake-ul .fake-li{width:94%}}
  `],
  inputs: [
    ...DEFAULT_INPUTS_O_BAR_MENU
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Injector, },
];
}


export class OBarMenuModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OBarMenuComponent],
  imports: [OSharedModule, CommonModule],
  exports: [OBarMenuComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
